import moment from 'moment';
import DateTimePicker from 'react-datetime';

type Props = {
  value: number | null;
  onChange: (epochMs: number) => void;
  disabled?: boolean;
  inputId?: string;
};

// A UTC+0 date-time picker (utc={true}, the Gacha / Live Event precedent). Values are epoch ms.
export function PushUtcDateTime({ value, onChange, disabled = false, inputId }: Props): JSX.Element {
  return (
    <DateTimePicker
      dateFormat="YYYY-MM-DD"
      timeFormat="HH:mm"
      utc={true}
      value={value != null ? moment.utc(value) : undefined}
      onChange={(date) => {
        // A string is a partially typed value: ignore it until it parses.
        if (moment.isMoment(date) && date.isValid()) {
          onChange(date.valueOf());
        }
      }}
      inputProps={{ disabled, id: inputId }}
    />
  );
}
